import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import {
  DossierSectionOptions,
  DossierSectionStatusOptions,
} from 'features/captains-form/slices/constants';
import {
  createPortcallStatusLog,
  getPortcallStatusLog,
} from 'features/captains-form/slices/portCallSlice';

import { selectSafetyDocumentsByTitle } from '../../../slices/documentsSlice';

import UploadDownloadBox from './UploadDownloadBox';
import Page from '../../../../layout/components/Page';
import PageHeader from '../../../../layout/components/PageHeader';
import SkipAndNextButtons from '../../port-call-data/components/SkipAndNextButtons';

import '../../summary/styles/summary.scss';
import '../styles/local-formalities.scss';

function LocalFormalities() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const safetyDocumentsByTitle = useSelector(selectSafetyDocumentsByTitle);
  const [documents, setDocuments] = useState([]);
  const [submitEnabled, setSubmitEnabled] = useState(true);
  const nonMandatoryDocuments = [
    'NIL LIST',
    'Ship Stores',
    'Crew Effects',
    'Bonded Stores',
  ];

  const onSubmitClick = async () => {
    if (params.uid) {
      const isSuccessUpdateStatus = await dispatch(
        createPortcallStatusLog({
          statusLog: {
            uid: params.uid,
            section: DossierSectionOptions.LocalFormalities,
            status: DossierSectionStatusOptions.SubmittedToNmap,
          },
        })
      ).then((response) => {
        if (response.type && response.type.endsWith('/rejected')) return false;
        else return true;
      });
      if (!isSuccessUpdateStatus) return;

      dispatch(getPortcallStatusLog(params.uid));
    }
    navigate(`/${params.uid}/ship-certificates`);
  };

  useEffect(() => {
    let documents = [];
    ['Terminals', 'Pilots', 'Health', 'Other'].forEach((category) => {
      documents = documents.concat(safetyDocumentsByTitle[category] ?? []);
    });
    setDocuments(documents);

    setSubmitEnabled(true);
    documents.forEach((document) => {
      if (
        !nonMandatoryDocuments.includes(document?.name) &&
        !document?.documentUid
      ) {
        setSubmitEnabled(false);
      }
    });
  }, [safetyDocumentsByTitle]);

  const renderDocuments = () => {
    return (
      <>
        <div className="local-formalities">
          <PageHeader title="Local formalities" />
          <div className="section">
            <div className="section-heading">
              1. Local Formalities: Fill and Submit
            </div>
            <div className="section-subheading">
              Download, complete and upload the requested documents.
            </div>
            <div className="doc-list-container">
              <div className="documents-list">
                {documents.map((document, i) => {
                  return (
                    <UploadDownloadBox
                      key={`doc-${i}`}
                      category="localFormalities"
                      document={document}
                      documentUid={document.documentUid}>
                      {document.documentType?.name === 'Other'
                        ? document.documentType?.otherName
                        : document.documentType?.name}
                    </UploadDownloadBox>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="section">
            <div className="section-auto-gen">
              <div className="section-heading">
                2. Local Formalities: Auto-Generated
              </div>
            </div>
            <div className="section-subheading">
              Review the following auto-generated documents
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <Page>
      <div className="safety-documents">
        {renderDocuments()}
        <SkipAndNextButtons
          onSubmitClick={onSubmitClick}
          next={`/${params.uid}/ship-certificates`}
          back={`/${params.uid}/health/third-step`}
          submitLabel="Submit"
          submitDisabled={!submitEnabled}
        />
      </div>
    </Page>
  );
}
export default LocalFormalities;
